<script setup lang="ts">
    defineOptions({
        name: 'AuthLayout'
    });
</script>

<template>
    <div
        class="flex flex-col justify-center items-center min-h-screen z-10 bg-white px-3 py-20 lg:p-3"
    >
        <!-- <img
            class="absolute top-5 left-5 lg:top-11 lg:left-11 w-fit h-fit"
            src="@/assets/images/logo.svg"
            alt=""
        /> -->
        <div
            class="w-full md:w-3/5 lg:w-1/2 xl:w-5/12 2xl:w-1/3 p-8 md:p-11 rounded-2xl bg-white drop-shadow-xl z-10"
        >
            <RouterView />
        </div>
        <img class="absolute bottom-0 z-0" src="@/assets/images/authBackground.png" alt="" />
    </div>
</template>
